import React from 'react';
import ProcessingCard from './ProcessingCard';
import './ProcessingCard.css';

/**
 * ProcessingSection — Renders a "Processing" header and a list of
 * in-progress / failed generation cards above the completed history.
 *
 * Props:
 *   processingJobs – array of jobs with status 'processing'
 *   failedJobs     – array of jobs with status 'failed'
 *   onDismiss      – callback(jobId)
 *   onRetry        – optional callback(job)
 */
const ProcessingSection = ({ processingJobs = [], failedJobs = [], onDismiss, onRetry }) => {
  const all = [...processingJobs, ...failedJobs];
  if (all.length === 0) return null;

  // Sort newest first
  const sorted = [...all].sort((a, b) => new Date(b.startedAt) - new Date(a.startedAt));

  return (
    <div className="gen-section">
      <div className="gen-section-header">
        <span className="gen-section-label">Processing</span>
        <span className="gen-section-count">{sorted.length}</span>
      </div>
      {sorted.map(job => (
        <ProcessingCard
          key={job.id}
          job={job}
          onDismiss={onDismiss}
          onRetry={onRetry}
        />
      ))}
    </div>
  );
};

export default ProcessingSection;
